import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20coral%20red%20and%20deep%20warm%20amber%20tones%2C%20soft%20diffused%20light%2C%20modern%20minimal%20design%2C%20no%20text%2C%20smooth%20gradients%2C%20artistic%20style%2C%20dark%20corners%20fading%20to%20warm%20center%2C%20elegant%20abstract%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
            <div className="flex-1 w-full pt-16 md:pt-20">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full text-background-50 text-sm mb-6 border border-background-50/20">
                <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
                实时爆料中 · 今日已更新128条
              </span>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-6">
                全网最新<span className="text-primary-400">劲爆大瓜</span><br />
                一网打尽 <span className="text-accent-400">吃瓜不停</span>
              </h1>
              <p className="text-background-50/70 text-base md:text-lg max-w-xl leading-relaxed mb-8">
                不必苦苦寻找吃瓜传送门，进入91曝光网即刻开启全网最新反差大瓜的高能之旅。
                深扒网红黑料，追踪社会热点，做最懂你的吃瓜导航平台。
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <Link
                  to="/category/wanghong-heidiao"
                  className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                >
                  立即吃瓜 <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/about"
                  className="text-background-50/80 hover:text-background-50 text-base underline underline-offset-4 decoration-background-50/30 hover:decoration-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  了解更多 →
                </Link>
              </div>
            </div>

            <div className="hidden lg:flex flex-col gap-4 w-[380px] flex-shrink-0 pt-20">
              <div className="bg-background-50/10 backdrop-blur-md rounded-2xl p-4 border border-background-50/10">
                <div className="flex items-center gap-3">
                  <span className="w-3 h-3 bg-accent-500 rounded-full animate-pulse"></span>
                  <span className="text-background-50/90 text-sm font-medium">最新推送</span>
                </div>
                <div className="mt-3 flex flex-col gap-3">
                  {[
                    '某千万粉丝网红人设崩塌',
                    '知名女星深夜密会新恋情',
                    '直播带货翻车品牌道歉',
                  ].map((title, i) => (
                    <div key={i} className="flex items-center gap-2 text-background-50/60 text-xs hover:text-background-50/90 transition-colors cursor-pointer">
                      <i className="ri-fire-line text-primary-400"></i>
                      <span className="truncate">{title}</span>
                      <span className="text-background-50/30 flex-shrink-0">刚刚</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}